/**
 *
 * Manage Obs Page
 *
 */

import React, { useState, useEffect, useRef } from "react"
import MetaTags from "react-meta-tags"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import Select from "react-select"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Table,
  Spinner,
  Input,
  // Badge,
  FormGroup,
  UncontrolledTooltip,

  // CardTitle
} from "reactstrap"
import { ToastContainer, toast } from "react-toastify"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import { isEmpty } from "lodash"
import * as obsAction from "../../store/bWFuYWdlLW9icw/actions"
import { useSelector, useDispatch } from "react-redux"
//Bootstrap table
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import { CSVExport } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import Modal from "react-bootstrap/Modal"
import moment from "moment"
import ButtonSpinner from "../../components/ButtonSpinner"
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import obs_import from "./obs_import.xlsx"
//import import_obs from "../../components/DataTable/obs_import2.xlsx"
import api from "helpers/Api"
import SimpleReactValidator from "simple-react-validator"
import "./styles.scss"

const ManageObsDetails = (props) => {
  const title = "Manage Obs"

  const { SearchBar } = Search
  const { dispatch, searchBarStyle, FlagImportInward } = props
  const specificDispatch = useDispatch()

  //const searchAutocompleteRef = useRef(null)

  const simpleValidator = useRef(new SimpleReactValidator())
  const simpleLeadValidator = useRef(new SimpleReactValidator())
  const simpleRejectValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()
  const [, leadForceUpdate] = useState()
  const [, rejectForceUpdate] = useState()

  function addZeroBefore(number) {
    var numberString = "0" + number
    if (number < 10) {
      return numberString
    } else {
      return number
    }
  }

  var currentDateMoment = moment().format("YYYY-MM-DD")
  var currentHourMoment = addZeroBefore(moment().format("HH"))
  var currentMinuteMoment = addZeroBefore(moment().minutes())
  var currentDateTimeMoment =
    currentDateMoment + "T" + currentHourMoment + ":" + currentMinuteMoment
  console.log(currentDateTimeMoment, "currentDateTimeMoment")
  //Api progress
  useEffect(() => {
    dispatch(obsAction.loadEmployee())
    dispatch(obsAction.loadObsList())
    dispatch(obsAction.loadRecordsMetaData())
    setFollowUpData({
      futureFollowUpDate: currentDateTimeMoment,
    })
  }, [1])

  const update = useSelector((state) => state.manageobs)
  const sessionUpdate = useSelector((state) => state.session)
  const { user = {} } = sessionUpdate
  const authUser = localStorage.getItem("authUser")

  const responseLogin = JSON.parse(authUser)

  const dateSetting =
    !isEmpty(responseLogin) &&
      responseLogin.setting &&
      responseLogin.setting.dateFormate
      ? responseLogin.setting.dateFormate.toUpperCase()
      : !isEmpty(user) && user.setting && user.setting.dateFormate
        ? user.setting.dateFormate.toUpperCase()
        : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  const {
    employee_list = [],
    obs_list = [],
    obsMetaData = {},
    followup_list,
  } = update

  //Source dropdown
  const [leadSource, setLeadSource] = useState([])
  const [leadSubSource, setLeadSubSource] = useState([])

  //Modal

  //import modal
  const [importModal, setImportModal] = useState(false)
  //update modal
  const [updateObsModal, setUpdateObsModal] = useState(false)
  const [followUpModal, setFollowUpModal] = useState(false)
  //delete  obs modal
  const [deleteModal, setDeleteModal] = useState(false)
  const handleObsModal = () => setUpdateObsModal(false)

  //follow up history view modal
  const [followUpHistoryModal, setFollowUpHistoryModal] = useState(false)
  const [searchValueList, setSearchValueList] = useState({})
  //button spinner state
  const [btnLoader, setBtnLoader] = useState(false)
  console.log(searchValueList, "searchValueList")
  const [agent,setAgent] = useState([])
  // filter form initial state
  const [manageObsData, setManageObsData] = useState({
    fromDate: "",
    toDate: "",
    followupFromDate: "",
    followupToDate: "",
  })
  //handle change
  const handleChange = async (e) => {
    setManageObsData({ ...manageObsData, [e.target.name]: e.target.value })
  }
  //dropdown initial state
  const [salesAgent, setSalesAgent] = useState([])
  //employee options(agent options)

  const employeeList =
    !isEmpty(employee_list) &&
    employee_list.map((employee) => {
      return {
        _id: employee._id,
        empCode: employee.empCode,
        name: employee.name,
        companyId: employee.companyId,
        roleId: employee.roleId,
      }
    })

  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee = element.empCode.concat(" - ", element.name)
        // [...element.empCode,...element.name].join('')

        let obj = {}
        obj.value = element._id
        obj.label = labelEmployee
        obj.empCode = element.empCode
        obj.companyId = element.companyId
        obj.roleId = element.roleId
        options.push(obj)
      })
    return options
  }

  const agentOptions = createOptions(employeeList)
  //fuse options for venue(autocomplete field)
  const fuseAgentOptions = {
    keys: ["empCode", "label"],
  }
  const [resetManager, setResetManager] = useState(false)
  const [agentKey,setAgentKey] = useState(false)
  const resetForm = () => {
    setManageObsData({
      fromDate: "",
      toDate: "",
      followupFromDate: "",
      followupToDate: "",
    })
    setLeadSource([])
    setLeadSubSource([])
    setAgentKey(true)
    setResetManager(true)
    setTimeout(() => {
      setAgentKey(false)
      setResetManager(false)
    }, 0)
    setSalesAgent([])
   
    setTimeout(() => {
      dispatch(obsAction.loadObsList())
    }, 2000)
  }

  //filter
  const applyFilter = () => {
    var searchAgent = salesAgent && salesAgent ? salesAgent.value : ""
    var searchSource = leadSource && leadSource ? leadSource.value : ""
    var searchSubSource =
      leadSubSource && leadSubSource ? leadSubSource.value : ""

    var searchFromDate =
      manageObsData && manageObsData.fromDate
        ? moment(manageObsData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      manageObsData && manageObsData.toDate
        ? moment(manageObsData.toDate).format("YYYY-MM-DD")
        : ""
    var searchFollowupFromDate =
      manageObsData && manageObsData.followupFromDate
        ? moment(manageObsData.followupFromDate).format("YYYY-MM-DD")
        : ""
    var searchFollowupToDate =
      manageObsData && manageObsData.followupToDate
        ? moment(manageObsData.followupToDate).format("YYYY-MM-DD")
        : ""
    var searchFilter = {}

    if (searchAgent) {
      searchFilter.agentId = searchAgent
    }
    if (searchFromDate) {
      searchFilter.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchFilter.toDate = searchToDate
    }
    if (searchSource) {
      searchFilter.leadSourceId = searchSource
    }
    if (searchSubSource) {
      searchFilter.subSourceId = searchSubSource
    }
    if (searchFollowupFromDate) {
      searchFilter.futureFollowupFrom = searchFollowupFromDate
    }
    if (searchFollowupToDate) {
      searchFilter.futureFollowupTo = searchFollowupToDate
    }
    setSearchValueList(searchFilter)
    console.log("filter values", applyFilter)
    specificDispatch(obsAction.loadObsList(searchFilter))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }
  //dropdown value fore mode
  const [mode, setMode] = useState([])
  const [rejectReason, setRejectReason] = useState([])
  //{id:data._id}
  const [dataFollowUp, setDataFollowUp] = useState("")
  const [agentAssignModal,setAgentAssignModal] = useState(false)
  //datatable
  let slNo = 0
  const manageObsDataTable = !isEmpty(obs_list)
    ? obs_list.map((data, index) => {
      slNo = slNo + 1
      

      const futureFollowupDate = !isEmpty(data.futureFollowupDate)
        ? moment(data.futureFollowupDate)
          .subtract(5, "hours")
          .subtract(30, "minutes")
          .format(dateFormate)
        : "--"
        const colorCode =
        !isEmpty(obsMetaData) &&
        obsMetaData.processStatusOptions &&
        obsMetaData.processStatusOptions.length > 0 &&
        obsMetaData.processStatusOptions.find(
          (_) => _. processStatusId === data.processStatus
        ) &&
        obsMetaData.processStatusOptions.find(
          (_) => _. processStatusId === data.processStatus
        ).colorCode
      return {
        key: index,
        sNo: slNo,
        _id: data._id,
        action: (
          <div className="d-flex flex-row">
            <Button
              type="submit"
              onClick={() => {
                // setEditvendor(true)
                setUpdateObsModal(true)
                updateObs(data)
              }}
              style={{ fontSize: "10px" }}
              className="btn btn-success buttons"
            >
              <i className="fas fa-pencil-alt icon-btn"></i>
            </Button>
            <Button
              type="submit"
              onClick={() => {
                setDeleteModal(true)
                editDeleteModal(data)
              }}
              style={{ fontSize: "10px", marginLeft: "3px" }}
              className="btn btn-danger buttons"
            >
              <i className="fas fa-trash-alt icon-btn"></i>
            </Button>
          </div>
        ),
        name: data.name,
        email: data.email != null ? data.email : "",
        date: data.date ? moment(data.date).format("DD-MM-YYYY") : "_",
        contactNo: data.contactNo,
        source: data.source != undefined ? data.source : "--",
        subSource: data.subSource != undefined ? data.subSource : "--",
        agentId: data.agentId,
        agentName: data.agentName != undefined ? data.agentName : "--",
        agentCode: data.agentCode,
        processStatusNameValue:data.processStatusName?data.processStatusName:"--",
        processStatusName: (
          <button
            style={{
              background: colorCode,
              border: "none",
              cursor: "pointer",
              color: "white",
              padding: "2px",
              borderRadius: "4px",
            }}
          >
            {data.processStatusName}
          </button>
        ),
        status: data.processStatus,
        // futureFollowUpDate:data.futureFollowupDate?data.futureFollowupDate.map(m=>moment(m).format(dateFormat)).join(","):"--",
        futureFollowupDate: futureFollowupDate,

        followUpHistory: (
          <p
            className="text-decoration-underline text-info"
            onClick={() => {
              setFollowUpHistoryModal(true)
              dispatch(obsAction.loadFollowUp({ obsImportId: data._id }))
            }}
          >
            History
          </p>
        ),
        obsNo:data.obsNo?data.obsNo:"--",
        followup: (
          <Button
            className="btn btn-info"
            onClick={() => {
              setFollowUpModal(true)
              setMode({ label: "Followup", value: "followup" })
              setDataFollowUp(data)
              clearData()
              setUploadInput([])
              setAttachmentFile([])
              setUploadAttachment([])
            }}
          >
            Follow Up
          </Button>
        ),
      }
    })
    : []

  let [selectedRows, setSelectedRows] = useState([])
  //const [updateButton,setUpdateButton] = useState(false)
  //initial state for row selection
  const [rowSelected, setRowSelected] = useState(false)
  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setSelectedRows([...selectedRows, row])
      setRowSelected(true)

    } else {
      setSelectedRows(selectedRows.filter((r) => r._id !== row._id))
      setRowSelected(false)
    }

  }

  const handleOnSelectAll = (isSelect, rows) => {
    if (isSelect) {
      setSelectedRows(rows)
      setRowSelected(true)
    } else {
      setSelectedRows([])
      setRowSelected(false)
    }
  }
  const selectRow = {
    mode: "checkbox",
    clickToSelect: false,
    clickToEdit: false,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
    selected: selectedRows.map((_) => _._id),
  }
  console.log(rowSelected)
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
      csvText: "S.No",
    },
    {
      dataField: "action",
      text: "Action",
      csvExport: false,
      csvText: "Action",
      headerStyle: {
        minWidth: "145px",
      },
    },

    {
      dataField: "date",
      text: "Date",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
      csvText: "Date",
      csvType: Number,
    },
    {
      dataField: "obsNo",
      text: "OBS No",
      sort: true,
      csvText: "OBS No",
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
      csvText: "Name",
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "contactNo",
      text: "Contact No",
      sort: true,
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "150px",
      },
      csvText: "Contact No",
      csvType: Number,
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      headerStyle: {
        minWidth: "170px",
      },
      csvText: "Email",
    },
    {
      dataField: "source",
      text: "Source",
      sort: true,
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "155px",
      },
      csvText: "Source",
    },
    {
      dataField: "subSource",
      text: "Sub Source",
      sort: true,
      headerStyle: {
        minWidth: "165px",
      },
      csvText: "Sub Source",
    },
    {
      dataField: "agentName",
      text: "Sales Agent Name",
      sort: true,
      headerStyle: {
        minWidth: "185px",
      },
      csvText: "Agent(empcode)",
    },
    {
      dataField: "futureFollowupDate",
      text: "Future Followup Date",
      sort: true,
      csvExport: false,
      headerStyle: {
        minWidth: "190px",
      },
      csvText: "Future Followup Date",
    },
    {
      dataField: "followup",
      text: "Follow Up",
      sort: true,
      csvExport: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "followUpHistory",
      text: "Follow Up History",
      sort: true,
      csvExport: false,
      headerStyle: {
        minWidth: "175px",
      },
    },

    {
      dataField: "processStatusName",
      text: "Status",
      sort: true,
      csvExport:false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "processStatusNameValue",
      text: "Status",
      sort: true,
      hidden:true,
      csvExport:true,
      headerStyle: {
        minWidth: "150px",
      },
    },
  ]

  const importTableColumns = [
    { dataField: "sNo", text: "S.No" },
    { dataField: "date", text: "Date" },
    { dataField: "name", text: "Name" },
    { dataField: "contactNo", text: "Contact No" },
    { dataField: "source", text: "Source" },
    { dataField: "subSource", text: "Sub Source" },
    { dataField: "agentName", text: "Sales Agent Name" },
    { dataField: "processStatusName", text: "Status" },
    // { dataField: "9", text: "Email (Personal)" },
    // { dataField: "10", text: "Date of Birth" },
    // { dataField: "11", text: "Date of Joining" },
  ]
  //download feature in data table
  const { ExportCSVButton } = CSVExport
  // pagination options
  const options = {
    sizePerPage: 50,
    // totalSize: manageEc_details.length, // replace later with size(customers),
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  //edit cross promotion

  const [empImportName, setEmpImportName] = useState("")

  const [uploading, setUploading] = useState(false)
  const [invalidData, setInvalidData] = useState([])

  const [importObsData, setImportObsData] = useState([])

  //const [importData,setImportData] = useState("")

  // console.log(importObsData, "importObsData")
  const [importLoading, setImportLoading] = useState(false)
  // const uploadImportApi = () => {
  //   let file =
  //     document.getElementById("obsImpFile") &&
  //     document.getElementById("obsImpFile").files
  //   var fileArrayDetails = Array.from(file)
  //   var teamUploadValue = uploadInput

  //   for (let x in fileArrayDetails) {
  //     const formData = new FormData()
  //     formData.append("file", fileArrayDetails[x])
  //     api
  //       .post("/obs_import_details", formData)
  //       .then(async (res) => {
  //         if (res && res.data && res.data.data) {
  //           teamUploadValue.push(res.data.data)
  //           await setUploadInput(teamUploadValue)
  //         } else {
  //           alert("Upload Failed!. Please try again")
  //         }
  //       })
  //       .catch(() => {
  //         alert("Unable to Upload file")
  //       })
  //   }
  // }
  //console.log(uploadInput, "upload input")
  const importEvent = (event) => {
    // console.log(event.target.files)
    // setUploading(true)
    // let files = document.getElementById('obsImpFile') && document.getElementById('obsImpFile').files
    setImportLoading(true)
    setTimeout(() => {
      let files =
        document.getElementById("obsImpFile") &&
        document.getElementById("obsImpFile").files
      setImportLoading(false)
      files ? files : (files = event.target.files)
      // console.log(files,files.length)
      if (files && files.length >= 0 && files[0]) {
        setUploading(true)
        setEmpImportName(files[0].name)
        const formd = new FormData()
        formd.append("import_file", files[0])
        api
          .post("/obs_import_details", formd)
          .then((res) => {
            if (res && res.data.success && res.data.data) {
              toast.success("upload successfully")
              setUploadInput(res.data.data.insertDetails)
              setTimeout(() => { }, 2000)
              setImportModal(false)

              setTimeout(() => {
                // document.getElementById("download1").click()
                // document.getElementById("download2").click()
                if (document.getElementById("download2")) {
                  // if (invalidData.length > 0) {
                  document.getElementById("download2").click()
                  // }
                }

                if (document.getElementById("download1")) {
                  // if (uploadInput.length > 0) {
                  document.getElementById("download1").click()
                  // }
                }
                if (uploadInput.length > 0) {
                  dispatch(obsAction.loadObsList())
                }
                // document.getElementById("download1").click()
              }, 2000)
            } else {
              if (!res.data.success) {
                toast.error(res.data.message)
              }
            }
            setImportObsData(res.data.data.insertDetails)
            setInvalidData(res.data.data.invalidDetails)
          })
          .catch((error) => {
            toast.error(error?.message || "Unable to Upload file")
          })
          .finally(() => {
            setImportModal(false)
            setUploading(false)
            setEmpImportName("")
          })
      } else {
        toast.error("Unable to Upload file Try Again")

        setUploading(false)
      }
    }, 20000)
  }
  const fuseOptions = {
    keys: ["empCode", "label"],
  }
  //Update section
  //initial state for update obs modal
  const [updateObsData, setUpdateObsData] = useState({
    _id: "",
    date: "",
    name: "",
    contactNo: "",
    email: "",
    empCode: "",
  })
  //handle change
  const handleUpdateChange = async (e) => {
    setUpdateObsData({ ...updateObsData, [e.target.name]: e.target.value })
  }
  //initial state for update obs modal dropdowns
  const [source, setSource] = useState([])
  const [subSource, setSubSource] = useState([])

  //edit functionality for update obs modal
  const updateObs = (data) => {
    var dateValue = moment(data.date).format("YYYY-MM-DD")
    setUpdateObsData({
      ...updateObsData,
      _id: data._id,
      date: dateValue,
      name: data.name,
      contactNo: data.contactNo,
      email: data.email,
      empCode: data.empCode,
    })
    setSubSource({ label: data.subSource, value: data.subSourceId })
    setSource({ label: data.source, value: data.sourceId })
  }
  const searchValue = !isEmpty(searchValueList) ? searchValueList : ""
  //update obs submit
  const obsUpdateSubmit = () => {
    const obsDetails = {
      _id: updateObsData._id,
      date: updateObsData.date,
      name: updateObsData.name,
      contactNo: updateObsData.contactNo,
      email: updateObsData.email,
      sourceId: source.value,
      subSourceId: subSource.value,
      empCode: updateObsData.agentCode,
    }

    dispatch(obsAction.updateObsList(obsDetails))
    setTimeout(() => {
      dispatch(obsAction.loadObsList(searchValue))
      toast.success("updated successfully")
    }, 1000)
    setUpdateObsModal(false)
  }

  //delete obs
  const editDeleteModal = (data) => {
    setUpdateObsData({ ...updateObsData, _id: data._id })
  }
  const deleteObs = () => {
    const deleteData = {
      _id: updateObsData._id,
      status: 3,
    }

    dispatch(obsAction.deleteObs(deleteData))
    setTimeout(() => {
      dispatch(obsAction.loadObsList(searchValue))
      toast.success("Deleted successfully")
    }, 1000)
  }

  //followup modal data
  const [followUpData, setFollowUpData] = useState({
    followUpDate: "",
    time: "",
    reachStatus: "",
    followUpRemarks: "",
    rejectfollowUpRemarks: "",
    leadfollowUpRemarks: "",
    attachment: [],
    futureFollowUpDate: "",
  })
  //handle change

  const handleFollowUpChange = async (e) => {
    setFollowUpData({ ...followUpData, [e.target.name]: e.target.value })
  }

  //folowwup dropdown initial state
  const [followUpMode, setFollowUpMode] = useState([])
  const [rejectedFollowupMode, setRejectedFollowupMode] = useState([])
  const [leadFollowupMode, setLeadFollowupMode] = useState([])
  const [futureFollowUpMode, setFutureFollowUpMode] = useState([])
  const [followUpStatus, setFollowUpStatus] = useState([])
  const [rejectedFollowUpStatus, setRejectedFollowUpStatus] = useState([])
  const [leadFollowUpStatus, setLeadFollowUpStatus] = useState([])
  const [followUpStrategy, setFollowUpStrategy] = useState([])

  const [uploadInput, setUploadInput] = useState([])
  const [attachmentFile, setAttachmentFile] = useState([])
  const [uploadAttachment, setUploadAttachment] = useState([])

  const [fileName, setFileName] = useState("")
  const [fileLength, setFileLength] = useState("")
  const [attachFileName, setAttachFileName] = useState("")
  const [attachFileLength, setAttachFileLength] = useState("")
  const [uploadFileName, setUploadFileName] = useState("")
  const [uploadFileLength, setUploadFileLength] = useState("")

  console.log(fileName, attachFileName, uploadFileName, "attachment files")
  console.log(fileName, attachFileName, uploadFileName, "attachment files")
  console.log(
    followUpMode,
    futureFollowUpMode,
    followUpStatus,
    followUpStrategy,
    "select attachment files"
  )
  console.log(uploadInput, "uplaodInput")
  !isEmpty(obs_list)
    ? obs_list.map((data, index) => {
      slNo = slNo + 1
      return {
        key: index,
        sNo: slNo,
        _id: data._id,
        action: (
          <div className="d-flex flex-row">
            <Button
              type="submit"
              onClick={() => {
                // setEditvendor(true)
                setUpdateObsModal(true)
                updateObs(data)
              }}
              style={{ fontSize: "10px" }}
              className="btn btn-success buttons"
            >
              <i className="fas fa-pencil-alt icon-btn"></i>
            </Button>
            <Button
              type="submit"
              onClick={() => {
                setDeleteModal(true)
                editDeleteModal(data)
              }}
              style={{ fontSize: "10px", marginLeft: "3px" }}
              className="btn btn-danger buttons"
            >
              <i className="fas fa-trash-alt icon-btn"></i>
            </Button>
          </div>
        ),
        obsNo: data.obsNo,
        name: data.name,
        email: data.email != null ? data.email : "",
        date: data.date ? moment(data.date).format("DD-MM-YYYY") : "_",
        contactNo: data.contactNo,
        source: data.source != undefined ? data.source : "--",
        subSource: data.subSource != undefined ? data.subSource : "--",
        agentId: data.agentId,
        agentName: data.agentName != undefined ? data.agentName : "--",
        updateAgentCode: data.agentName != undefined ? data.agentName : "",
        agentCode: data.agentCode,
        processStatusName: data.processStatusName,
        status: data.processStatus,
        // futureFollowUpDate:data.futureFollowupDate?data.futureFollowupDate.map(m=>moment(m).format(dateFormat)).join(","):"--",
        futureFollowUpDate: data.futureFollowupDate
          ? data.futureFollowupDate
          : "--",

        followUpHistory: (
          <p
            className="text-decoration-underline text-info"
            onClick={() => {
              setFollowUpHistoryModal(true)
              dispatch(obsAction.loadFollowUp({ obsImportId: data._id }))
            }}
          >
            History
          </p>
        ),
        followup: (
          <Button
            className="btn btn-info"
            onClick={() => {
              setFollowUpModal(true)
              setMode({ label: "Followup", value: "followup" })
              setDataFollowUp(data)
              clearData()
              setUploadInput([])
              setAttachmentFile([])
              setUploadAttachment([])
            }}
          >
            Follow Up
          </Button>
        ),
      }
    })
    : []
  const invalidDataWithSNo = !isEmpty(invalidData)
    ? invalidData.map((data, index) => {
      return {
        sNo: index + 1,
        _id: data._id,
        obsNo: data.obsNo,
        name: data.name,
        email: data.email != null ? data.email : "",
        date: data.date ? moment(data.date).format("DD-MM-YYYY") : "_",
        contactNo: data.contactNo,
        source: data.source != undefined ? data.source : "--",
        subSource: data.subSource != undefined ? data.subSource : "--",
        agentId: data.agentId,
        agentName: data.agentName != undefined ? data.agentName : "--",
        agentCode: data.agentCode,
        processStatusName: data.processStatusName,
        status: data.processStatus,
        // futureFollowUpDate:data.futureFollowupDate?data.futureFollowupDate.map(m=>moment(m).format(dateFormat)).join(","):"--",
        futureFollowUpDate: data.futureFollowupDate
          ? data.futureFollowupDate
          : "--",
      }
    })
    : []

  console.log(invalidData, "invalidData")
  console.log(invalidDataWithSNo, "invalidDataWithSNo")
  const uploadChange = async (e) => {
    if (e.target.files) {
      // console.log("qqqq", e.target.files)
      setUploadInput(e.target.files)
      var file = e.target.files
      setFileName(file[0].name)
      setFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = uploadInput

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setUploadInput(teamUploadValue)
          }
        })
      }
    }
  }
  const attachmentChange = async (e) => {
    if (e.target.files) {
      // console.log("qqqq", e.target.files)
      setAttachmentFile(e.target.files)
      var file = e.target.files
      setAttachFileName(file[0].name)
      setAttachFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = attachmentFile

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setAttachmentFile(teamUploadValue)
          }
        })
      }
    }
  }

  const fileChange = async (e) => {
    if (e.target.files) {
      // console.log("qqqq", e.target.files)
      setUploadAttachment(e.target.files)
      var file = e.target.files
      setUploadFileName(file[0].name)
      setUploadFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = uploadAttachment

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setUploadAttachment(teamUploadValue)
          }
        })
      }
    }
  }
  // console.log(uploadInput, "myUpload")

  const currentDate = moment().format("YYYY-MM-DD")
  // console.log(currentDate, "currentDate")

  const currentTime = moment().format("LT")
  // console.log(currentTime)

  // const currentdateTime = moment().format("YYYY-MM-DD LT")
  // console.log(currentdateTime, "datetime")

  //initial state for crosspromotion
  const [crossPromotionData, setCrossPromotionData] = useState([
    {
      company: "",
      companyId: "",
      branch: "",
      branchId: "",
      serviceId: "",
      service: "",
      followUpRemarks: "",
      convertSalesUrge:"",
      convertSalesUrgeId:""
    },
  ])
  const [renderPage, setRenderPage] = useState(false)
  // const [addPromotions, setAddPromotions] = useState(false)
  const addCrossPromotion = async () => {
    setCrossPromotionData([
      ...crossPromotionData,
      {
        company: "",
        companyId: "",
        branch: "",
        branchId: "",
        serviceId: "",
        service: "",
        followUpRemarks: "",
        convertSalesUrge:"",
        convertSalesUrgeId:""
      },
    ])
    setRenderPage(!renderPage)
    // setAddPromotions(false)
  }
  console.log(followUpData, "followupdata")
  const clearData = () => {
    setFollowUpMode([])
    setLeadFollowupMode([])
    setRejectedFollowupMode([])
    setRejectReason([])
    setCheckOption({ option: "", checked: "" })
    setFlagOption({ option: "", checked: "" })
    setRadioOption({ option: "", checked: "" })
    setReachOption({ option: "", checked: "" })
    setFileName("")
    setFileLength("")
    setAttachFileName("")
    setAttachFileLength("")
    setUploadFileName("")
    setUploadFileLength("")
    setFollowUpData({ ...followUpData, followUpRemarks: "",rejectfollowUpRemarks:"",leadfollowUpRemarks:"" })
    setFollowUpStatus([])
    setLeadFollowUpStatus([])
    setRejectedFollowUpStatus([])
    setFutureFollowUpMode([])
    setFollowUpStrategy([])
    setCrossPromotionData()
    setCrossPromotionData([
      {
        ...crossPromotionData,
        company: "",
        companyId: "",
        branch: "",
        branchId: "",
        serviceId: "",
        service: "",
        followUpRemarks: "",
        leadfollowUpRemarks:"",
        convertSalesUrge:"",
        convertSalesUrgeId:""
      },
    ])
  }
 
  const modalChange = async (e, index, name) => {
    var crossPromotionList = crossPromotionData
    if (name == "followUpRemarks") {
      e = e.target.value
      crossPromotionList[index][name] = e
      setCrossPromotionData(crossPromotionList)
    }

    if (name == "companyId") {
      crossPromotionList[index]["companyId"] = e.value
      crossPromotionList[index]["company"] = e.label
      setCrossPromotionData(crossPromotionList)
    }
    if (name == "branchId") {
      crossPromotionList[index]["branchId"] = e.value
      crossPromotionList[index]["branch"] = e.label
      setCrossPromotionData(crossPromotionList)
    }
    if (name == "serviceId") {
      crossPromotionList[index]["serviceId"] = e.value
      crossPromotionList[index]["service"] = e.label
      setCrossPromotionData(crossPromotionList)
    }
    if (name == "convertSalesUrgeId") {
      crossPromotionList[index]["convertSalesUrgeId"] = e.value
      crossPromotionList[index]["convertSalesUrge"] = e.label
      setCrossPromotionData(crossPromotionList)
    }
    setRenderPage(!renderPage)
  }
  const removeCrossPromotion = async (toRemove) => {
    var crossPromotionList = crossPromotionData
    if (toRemove != 0) {
      if (toRemove > -1) {
        crossPromotionList.splice(toRemove, 1)
      }
      setCrossPromotionData(crossPromotionList)
      setRenderPage(!renderPage)
    }
  }
  const promotionData =
    !isEmpty(crossPromotionData) && crossPromotionData.length > 0
      ? crossPromotionData.map((data) => {
        if (data) {
          return {
            companyId: data.companyId,
            branchId: data.branchId,
            serviceId: data.serviceId,
            remarks: data.followUpRemarks,
            salesUrge:data.convertSalesUrgeId,
            action: true,
          }
        }
      })
      : []

  const submitCrossPromotion = () => {
    if (mode.value === "followup") {
      if (simpleValidator.current.allValid()) {
        const submitFollowUp = {
          followupNo: dataFollowUp.obsNo,
          followupModeId: followUpMode.value,
          obsImportId: dataFollowUp._id,
          //assignedAgentId:  dataFollowUp.assignedAgentId?dataFollowUp.assignedAgentId:"",
          futureFollowupModeId: futureFollowUpMode.value,
          followUpStatus: followUpStatus.value,
          followUpRemarks: followUpData.followUpRemarks,
          followUpTime: currentTime,
          followUpDate: currentDate,
          futureFollowUpDateTime: followUpData.futureFollowUpDate,
          futureFollowUpStrategy: followUpStrategy.value,
          recordAttachment: uploadInput,
          actionType: 1,
          clientReachStatus: radioOption.option,
        }
        console.log(submitFollowUp, "submitFollowUp")
        dispatch(obsAction.addFollowUp(submitFollowUp))
        setTimeout(() => {
          dispatch(obsAction.loadObsList(searchValue))
          toast.success("Followup Added successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          })
          setFollowUpModal(false)
        }, 1000)
      } else {
        simpleValidator.current.showMessages()
        forceUpdate(1)
        setFollowUpModal(true)
      }
    }
  }
  const leadConveretedSubmit = () => {
    if (simpleLeadValidator.current.allValid()) {
      const submitFollowUp = {
        followupNo: dataFollowUp.obsNo,
        followupModeId: leadFollowupMode.value,
        obsImportId: dataFollowUp._id,
        followUpStatus: leadFollowUpStatus.value,
        followUpRemarks: followUpData.leadfollowUpRemarks,
        followUpTime: currentTime,
        followUpDate: currentDate,
        recordAttachment: uploadAttachment,
        actionType: 3,
        clientReachStatus: reachOption.option,
        crossPromotion: promotionData,
      }
      console.log(submitFollowUp, "submitFollowUp")
      dispatch(obsAction.addFollowUp(submitFollowUp))
      setTimeout(() => {
        dispatch(obsAction.loadObsList(searchValue))
        toast.success("Followup Added successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
        setFollowUpModal(false)
      }, 1000)
    } else {
      simpleValidator.current.showMessages()
      leadForceUpdate(1)
      setFollowUpModal(true)
    }
  }
  const rejectedSubmit = () => {
    if (simpleRejectValidator.current.allValid()) {
      const submitFollowUp = {
        followupNo: dataFollowUp.obsNo,
        followupModeId: rejectedFollowupMode.value,
        rejectReason: rejectReason.value,
        redFlag: flagOption.option,
        obsImportId: dataFollowUp._id,
        followUpStatus: rejectedFollowUpStatus.value,
        followUpRemarks: followUpData.rejectfollowUpRemarks,
        followUpTime: currentTime,
        followUpDate: currentDate,
        recordAttachment: attachmentFile,
        actionType: 2,
        clientReachStatus: checkOption.option,
      }
      console.log(submitFollowUp, "submitFollowUp")
      dispatch(obsAction.addFollowUp(submitFollowUp))
      setTimeout(() => {
        dispatch(obsAction.loadObsList(searchValue))
        toast.success("Followup Added successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
        setFollowUpModal(false)
      }, 1000)
    } else {
      simpleValidator.current.showMessages()
      rejectForceUpdate(1)
      setFollowUpModal(true)
    }
  }
  //dynamic radio button 1
  const [radioOption, setRadioOption] = useState({ option: "", checked: "" })

  const connectOptions = [
    { id: 1, option: "connected", label: "Connected" },
    { id: 2, option: "notConnected", label: "Not Connected" },
  ]

  const handleOptionsChange = (e, index) => {
    // console.log(connectOptions[index].option, "valueradio")
    let value = connectOptions[index].option
    setRadioOption({ option: value, checked: index })
  }

  //dynamic radio button 2
  const [checkOption, setCheckOption] = useState({ option: "", checked: "" })

  const checkOptions = [
    { id: 1, option: "connected", label: "Connected" },
    { id: 2, option: "notConnected", label: "Not Connected" },
  ]

  const handleCheckChange = (e, index) => {
    // console.log(checkOptions[index].option, "valueradio")
    let value = checkOptions[index].option
    setCheckOption({ option: value, checked: index })
  }

  //Flag options
  const [flagOption, setFlagOption] = useState({ option: "", checked: "" })
  const flagOptions = [
    { id: 1, option: "yes", label: "Yes" },
    { id: 2, option: "no", label: "No" },
  ]

  const handleFlagChange = (e, index) => {
    let value = flagOptions[index].option
    setFlagOption({ option: value, checked: index })
  }

  //dynamic radio button 3
  const [reachOption, setReachOption] = useState({ option: "", checked: "" })

  const reachStatusOptions = [
    { id: 1, option: "connected", label: "Connected" },
    { id: 2, option: "notConnected", label: "Not Connected" },
  ]

  const handleReachStatusChange = (e, index) => {
    // console.log(reachStatusOptions[index].option, "valueradio")
    let value = reachStatusOptions[index].option
    setReachOption({ option: value, checked: index })
  }
  
  const agentObsId = selectedRows&&selectedRows.map(m=>m._id)
  //update agent
  const updateAgent = () => {
    const agent_data = {
      "_id":agentObsId,
      "agentId": agent.value,
      "agentName": agent.name,
      "agentCode": agent.code
    }
    console.log(agent_data,"agentdata")
    dispatch(obsAction.updateAgent(agent_data))
    setTimeout(() => {
      dispatch(obsAction.loadObsList(searchValue))
      toast.success("Lead Assigned successfully")
      setSelectedRows([])
    }, 2000)
    setAgentAssignModal(false)
    setRowSelected(false)
   
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={"Obs"} breadcrumbItem={title} />
        </Container>

        {/**Filter Form Start */}
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"From Date"}>
                          {"From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="fromDate"
                        value={manageObsData.fromDate}
                        max={manageObsData.toDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"To Date"}>
                          {"To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="toDate"
                        value={manageObsData.toDate}
                        min={manageObsData.fromDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"From Date"}>
                          {"Future Followup From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="followupFromDate"
                        value={manageObsData.followupFromDate}
                        max={manageObsData.followupToDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"To Date"}>
                          {"Future Followup To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="followupToDate"
                        value={manageObsData.followupToDate}
                        min={manageObsData.followupFromDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>{"Lead Source"}</Label>
                      </div>
                      <Select
                        type="text"
                        name="leadSource"
                        value={leadSource}
                        onChange={(e) => setLeadSource(e)}
                        options={
                          obsMetaData.sourceOptions
                            ? obsMetaData.sourceOptions
                            : []
                        }
                        placeholder="Select Source"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>{"Lead Sub Source"}</Label>
                      </div>
                      <Select
                        type="text"
                        name="leadSubSource"
                        value={leadSubSource}
                        onChange={(e) => setLeadSubSource(e)}
                        options={
                          obsMetaData.subSourceOptions
                            ? obsMetaData.subSourceOptions
                            : []
                        }
                        placeholder="Select Sub Source"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>{"Sales Agent"}</Label>
                      </div>
                      <ReactSearchAutocomplete
                        name="salesAgent"
                        key={resetManager}
                        items={agentOptions}
                        value={salesAgent}
                        type="autoComplete"
                        resultStringKeyName="label"
                        showIcon={false}
                        onSelect={(e) => setSalesAgent(e)}
                        onChange={(e) => setSalesAgent(e.target.value)}
                        placeholder="Enter Sales Agent"
                        fuseOptions={fuseOptions} // Search on both fields
                        styling={{
                          height: "34px",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          backgroundColor: "white",
                          boxShadow: "none",
                          hoverBackgroundColor: "#E40D8C",
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "Courier",
                          iconColor: "green",
                          clearIconMargin: "3px 8px 0 0",
                          zIndex: 10,
                        }}
                      />
                    </Col>
                  </Row>
                  <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                    <div className="filter-buttons" style={{ float: "right" }}>
                      <Button
                        type="button"
                        onClick={() => resetForm()}
                        className="btn btn-danger btn-label simple-form-Reset-btn"
                      >
                        <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                        Reset
                      </Button>
                      <Button
                        type="button"
                        onClick={() => applyFilter()}
                        className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                      >
                        <i className="bx bx-filter-alt label-icon"></i>
                        {btnLoader && btnLoader ? (
                          <ButtonSpinner />
                        ) : (
                          "Apply Filter"
                        )}{" "}
                      </Button>
                    </div>
                  </Col>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {/**Table Start */}
        <Col md="12" lg="12" xl="12">
          <Card>
            <CardBody>
              <PaginationProvider
                pagination={paginationFactory(options)}
                keyField="_id"
                columns={columns}
              >
                {({ paginationProps, paginationTableProps }) => (
                  <ToolkitProvider
                    keyField="_id"
                    data={manageObsDataTable}
                    columns={columns}
                    search
                    exportCSV
                  >
                    {(props) => (
                      <div>
                        <Col md="12" xl="12" lg="12" sm="12" xs="12">
                          <Row className="d-flex flex-row justify-content-between">
                            <Col className="mb-3" md="4">
                              <div className="d-flex flex-row ">
                                <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                  <div
                                    className="position-relative mt-7"
                                    style={searchBarStyle || null}
                                  >
                                    <SearchBar {...props.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </div>{" "}
                            </Col>

                            <Col md="8">
                              <div style={{ float: "right", display: "flex" }}>
                                {!isEmpty(invalidData) &&
                                  invalidData.length > 0 ? (
                                  <div
                                    className={
                                      invalidData.length > 0 ? "mx-2" : "d-none"
                                    }
                                    style={{
                                      background: "#f1b44c",
                                      "border-radius": "4px",
                                    }}
                                  >
                                    <ReactHTMLTableToExcel
                                      id="download2"
                                      className={
                                        invalidData.length > 0
                                          ? "download-table-xls-button btn  clr-"
                                          : "d-none"
                                      }
                                      table="Import3"
                                      filename="Invalid OBS"
                                      sheet="tablexls"
                                      buttonText="Invalid Data"
                                    />
                                  </div>
                                ) : (
                                  ""
                                )}
                                {!isEmpty(importObsData) &&
                                  importObsData.length > 0 ? (
                                  <div
                                    className={
                                      importObsData.length > 0
                                        ? "mx-2"
                                        : "d-none"
                                    }
                                    style={{
                                      background: "#f1b44c",
                                      "border-radius": "4px",
                                    }}
                                  >
                                    <ReactHTMLTableToExcel
                                      id="download1"
                                      className={
                                        importObsData.length > 0
                                          ? "download-table-xls-button btn  clr-"
                                          : "d-none"
                                      }
                                      table="Import2"
                                      filename="Existing OBS"
                                      sheet="tablexls"
                                      buttonText="Existing Data"
                                    />
                                  </div>
                                ) : (
                                  ""
                                )}


                                <div
                                  style={{
                                    marginRight: "6px",
                                  }}
                                >
                                  <Button
                                    className="btn btn-success"
                                    onClick={() => setImportModal(true)}
                                  >
                                    Import OBS{" "}
                                  </Button>{" "}
                                </div>
                                <div
                                  style={{
                                    float: "right",
                                    marginRight: "6px",
                                  }}
                                >
                                  {selectedRows.length > 0 && (
                                    <Button
                                      className="btn btn-danger text-nowrap"
                                      onClick={() => {
                                      setAgentAssignModal(true)
                                      }}
                                      style={{
                                        marginRight: "10px",
                                      }}
                                    >
                                      Lead Assign
                                    </Button>
                                  )}

                                </div>
                                <div
                                  style={{
                                    float: "right",
                                  }}
                                >
                                  <ExportCSVButton
                                    className="border float-right mx-10"
                                    style={{
                                      float: "right",
                                      backgroundColor: "#e40d8c",
                                      color: "#ffffff",
                                    }}
                                    {...props.csvProps}
                                  >
                                    Download OBS{" "}
                                  </ExportCSVButton>{" "}
                                </div>
                              </div>
                            </Col>

                            <Col>
                              <BootstrapTable
                                {...props.baseProps}
                                responsive
                                striped={true}
                                bordered={true}
                                keyField="_id"
                                columns={columns}
                                selectRow={selectRow}
                                // expandRow={expandRow}
                                id="ImportTable"
                                {...paginationTableProps}
                              />
                            </Col>
                          </Row>
                          <Row
                            style={{ marginTop: "5px" }}
                            className="align-items-md-center mt-30"
                          >
                            <Col className="inner-custom-pagination d-flex">
                              <div className="d-inline d-flex flex-row">
                                <SizePerPageDropdownStandalone
                                  {...paginationProps}
                                />
                                <div
                                  style={{
                                    fontSize: "14px",
                                    marginTop: "8px",
                                    marginLeft: "4px",
                                  }}
                                >
                                  <PaginationTotalStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </div>
                              <div
                                className="text-md-right ms-auto"
                                style={{ zIndex: 0 }}
                              >
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </div>
                    )}
                  </ToolkitProvider>
                )}
              </PaginationProvider>
              <Row>
                <div
                  style={{
                    float: "left",
                    marginRight: "6px",
                  }}
                >
                  {selectedRows.length > 0 && (
                    <Button
                      className="btn btn-danger text-nowrap"
                      onClick={() => {
                        setAgentAssignModal(true)
                        }}
                      style={{
                        marginRight: "10px",
                      }}
                    >
                     Lead Assign
                    </Button>
                  )}
                </div>
              </Row>
            </CardBody>
          </Card>
        </Col>
        <Col xl="12" className="d-flex">
          {!isEmpty(importObsData) && importObsData.length > 0 ? (
            <>
              <div className="d-none">
                <BootstrapTable
                  keyField="S.No"
                  data={!isEmpty(importObsData) ? importObsData : []}
                  id="Import2"
                  columns={importTableColumns || []}
                  className="d-none"
                />
                {/* <BootstrapTable
                  keyField="S.No"
                  data={!isEmpty(invalidData) ? manageObsDataTable : []}
                  id="Import3"
                  columns={importTableColumns || []}
                  className="d-none"
                />{" "} */}
              </div>
            </>
          ) : (
            ""
          )}
          {!isEmpty(invalidData) && invalidData.length > 0 ? (
            <>
              <div className="d-none">
                <BootstrapTable
                  keyField="S.No"
                  data={!isEmpty(invalidData) ? invalidDataWithSNo : []}
                  id="Import3"
                  columns={importTableColumns || []}
                  className="d-none"
                />{" "}
              </div>
            </>
          ) : (
            ""
          )}
        </Col>
        {importModal && (
          <Modal
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={importModal}
            size="md"
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
              id="contained-modal-title-vcenter"
            >
              Upload Excel
            </Modal.Header>
            <Modal.Body>
              <div className="pt-2">
                <h4>Instructions!</h4>
                <ul className="pl-5">
                  <li>Kindly Upload Only .xlsx files.</li>
                  <li>
                    The sheet consists of Product Name, Product Type, etc.
                    Fields marked are to be entered mandatory.
                  </li>
                  <li>
                    Download the Sample sheet attached for your reference{" "}
                    <span onClick={() => window.open(obs_import, "_self")}>
                      <i
                        style={{ cursor: "pointer" }}
                        className="bx bx-download fa-2x text-primary"
                      ></i>
                    </span>
                    .
                  </li>
                  <li>
                    Add the entries to the sheet.save it and upload the sheet.
                  </li>
                  <li>In case of any queries or issues, please contact.</li>
                </ul>
                <div>
                  <div style={{ width: "100px", height: "2px" }}>
                    <span
                      style={{
                        transition: "2 width",
                        display: "inline-block",
                        background: "#ccc",
                        height: "2px",
                      }}
                    ></span>
                  </div>

                  <React.Fragment>
                    <FormGroup className="no-margin">
                      {uploading ? (
                        <>
                          <div>Uploading File.....</div>
                          <div className="d-none">
                            <div
                              style={{
                                width: "600px",
                                height: "5px",
                                border: "1px solid #ccc",
                              }}
                            >
                              <span
                                style={{
                                  transition: "2 width",
                                  display: "inline-block",
                                  background: "#ccc",
                                  height: "2px",
                                }}
                              ></span>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div>
                            <input
                              type="file"
                              accept=".csv, 
                          application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, 
                          application/vnd.ms-excel"
                              id="obsImpFile"
                              onChange={(e) => importEvent(e)}
                              name="uploadInputs"
                            ></input>

                            <div>{empImportName ? empImportName : ""}</div>
                          </div>
                        </>
                      )}
                    </FormGroup>
                  </React.Fragment>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div>
                <Button
                  type="submit"
                  onClick={() => {
                    // uploadImportApi()
                    setTimeout(() => {
                      setImportModal(false)
                    }, 1000)
                  }}
                  className={
                    FlagImportInward && FlagImportInward === true
                      ? "d-block btn btn-success mx-2"
                      : "d-none btn btn-success"
                  }
                  variant="outline-success m-1 text-capitalize"
                >
                  {uploading ? "Uploading...." : "Import OBS"}
                </Button>
                <Button
                  type="submit"
                  onClick={() => {
                    setImportModal(false)
                    setEmpImportName("")
                  }}
                  style={{ fontSize: "10px", marginLeft: "20px" }}
                  className="btn btn-danger buttons"
                >
                  {" "}
                  Cancel
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
        {updateObsModal && (
          <Modal size="xl" show={updateObsModal} onHide={handleObsModal}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Edit OBS
            </Modal.Header>

            <Modal.Body>
              <Row className="d-flex flex-row">
                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <div className="d-flex justify-content-between">
                    <Label className="form-label" htmlFor={"Name"}>
                      {"Name"}
                    </Label>
                  </div>
                  <Input
                    type="text"
                    placeholder="Enter Name"
                    name="name"
                    value={updateObsData.name}
                    onChange={(e) => handleChange(e)}
                  />
                </Col>
                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <div className="d-flex justify-content-between">
                    <Label className="form-label" htmlFor={"To Date"}>
                      {"Date"}
                    </Label>
                  </div>
                  <Input
                    type="date"
                    placeholder="Select Date"
                    name="date"
                    value={updateObsData.date}
                    onChange={(e) => handleUpdateChange(e)}
                  />
                </Col>
                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <div className="d-flex justify-content-between">
                    <Label className="form-label" htmlFor={"Contact No"}>
                      {"Contact Number"}
                    </Label>
                  </div>
                  <Input
                    type="text"
                    placeholder="Enter Contact Number"
                    name="contactNo"
                    value={updateObsData.contactNo}
                    onChange={(e) => handleUpdateChange(e)}
                  />
                </Col>
                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <div className="d-flex justify-content-between">
                    <Label className="form-label" htmlFor={"Email"}>
                      {"Email"}
                    </Label>
                  </div>
                  <Input
                    type="text"
                    placeholder="Enter Email "
                    name="email"
                    value={updateObsData.email}
                    onChange={(e) => handleUpdateChange(e)}
                  />
                </Col>
              </Row>
              <Row className="d-flex flex-row">
                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <div className="d-flex justify-content-between">
                    <Label className={"form-label"}>{"Source"}</Label>
                  </div>
                  <Select
                    type="text"
                    name="source"
                    value={source}
                    onChange={(e) => setSource(e)}
                    options={obsMetaData ? obsMetaData.sourceOptions : []}
                    placeholder="Select Service"
                    classNamePrefix="select2-selection"
                  />
                </Col>
                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <div className="d-flex justify-content-between">
                    <Label className={"form-label"}>{" Sub Source"}</Label>
                  </div>
                  <Select
                    type="text"
                    name="subSource"
                    value={subSource}
                    onChange={(e) => setSubSource(e)}
                    options={obsMetaData ? obsMetaData.subSourceOptions : []}
                    placeholder="Select Service"
                    classNamePrefix="select2-selection"
                  />
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => setUpdateObsModal(false)}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                className="btn btn-success"
                onClick={() => obsUpdateSubmit()}
              >
                Update
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {deleteModal && (
          <Modal show={deleteModal} size="md">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Delete OBS Details
            </Modal.Header>
            <Modal.Body>Do you want To Delete the obs details?</Modal.Body>
            <Modal.Footer>
              <div>
                <Button
                  type="submit"
                  onClick={() => {
                    setDeleteModal(false)
                  }}
                  className="btn btn-danger buttons"
                >
                  {" "}
                  No
                </Button>
                <Button
                  type="submit"
                  onClick={() => {
                    deleteObs()
                    setTimeout(() => {
                      setDeleteModal(false)
                    }, 500)
                  }}
                  className="mx-2 btn btn-success buttons"
                >
                  {" "}
                  Yes
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
        {followUpModal && (
          <Modal size="xl" show={followUpModal}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Followup
            </Modal.Header>
            <Modal.Body>
              {mode.value === "followup" ? (
                <>
                  <Row className="quote-head-content">
                    <Col md="6" lg="6" sm="12">
                      <div className="d-flex">
                        <p className="quote-head">
                          Current Followup
                          <span className="quote-info">
                            <i
                              style={{ color: "grey" }}
                              id="quoteInfo1"
                              aria-hidden="true"
                              className="fa fa-info-circle ms-1"
                            ></i>
                            <UncontrolledTooltip
                              placement="right"
                              target="quoteInfo1"
                            >
                              Current Followup
                            </UncontrolledTooltip>
                          </span>
                        </p>
                        <div style={{ width: "150px" }}>
                          <Select
                            name="mode"
                            value={mode}
                            onChange={(e) => setMode(e)}
                            options={[
                              { label: "Followup", value: "followup" },
                              {
                                label: "Lead Converted",
                                value: "leadConverted",
                              },
                              { label: "Rejected", value: "rejected" },
                            ]}
                            placeholder="Select Mode"
                            classNamePrefix="select2-selection"
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row className="d-flex flex-row">
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className="form-label"
                          htmlFor={"Follow-Up-Date"}
                        >
                          {"Follow-Up-Date"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="followUpDate"
                        value={currentDate}
                        onChange={(e) => handleFollowUpChange(e)}
                        disabled
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"Time"}>
                          {"Time"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Input
                        type="text"
                        placeholder="Select Date"
                        name="time"
                        value={currentTime}
                        onChange={(e) => handleFollowUpChange(e)}
                        disabled
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Follow-Up-Mode"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Select
                        type="text"
                        name="followUpMode"
                        value={followUpMode}
                        onChange={(e) => setFollowUpMode(e)}
                        options={
                          obsMetaData ? obsMetaData.followUpModeOptions : []
                        }
                        placeholder="Select Follow Up Mode"
                        classNamePrefix="select2-selection"
                      />
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleValidator.current.message(
                          "followUpMode",
                          followUpMode,
                          "required"
                        )}
                      </div>
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Reach Status"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <div className="d-flex flex-row">
                        {connectOptions.map((item, index) => {
                          return (
                            <>
                              <div className="form-check form-check-inline">
                                <Input
                                  type="radio"
                                  key={item.id}
                                  name="Reach Status"
                                  value={radioOption.option}
                                  checked={radioOption.checked === index}
                                  onChange={(e) =>
                                    handleOptionsChange(e, index)
                                  }
                                />

                                <Label>{item.label}</Label>
                              </div>
                            </>
                          )
                        })}
                      </div>
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleValidator.current.message(
                          "Reach Status",
                          radioOption.option,
                          "required"
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Row className="d-flex flex-row mt-3">
                    <Col md="6" lg="6" sm="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"Time"}>
                          {"Follow-Up-Remarks"} {""}{" "}
                          <span className="text-decoration-underline text-info">
                            History
                          </span>
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Input
                        type="textarea"
                        placeholder="Enter Follow Up Remarks"
                        name="followUpRemarks"
                        value={followUpData.followUpRemarks}
                        onChange={(e) => handleFollowUpChange(e)}
                      />
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleValidator.current.message(
                          "followUpRemarks",
                          followUpData.followUpRemarks,
                          "required"
                        )}
                      </div>
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Attachment"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Button className=" btn btn-warning  position-relative fs-5">
                        <i className="fas fa-laptop"></i>

                        <Input
                          type="file"
                          name="uploadInput"
                          accept="application/pdf, audio/mp3 , image/jpeg"
                          // id="upload-btn"
                          multiple
                          onChange={(e) => uploadChange(e)}
                          style={{
                            position: "absolute",
                            fontSize: "50px",
                            opacity: 0,
                            right: 0,
                            top: 0,
                          }}
                        />
                        <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                          {fileLength ? fileLength : 0}
                        </span>
                      </Button>
                      <div className="text-decoration-underline text-danger">
                        {fileName ? fileName : ""}
                      </div>
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleValidator.current.message(
                          "Attachment",
                          uploadInput,
                          "required"
                        )}
                      </div>
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Follow-Up-Status"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Select
                        type="text"
                        name="followUpStatus"
                        value={followUpStatus}
                        onChange={(e) => setFollowUpStatus(e)}
                        options={
                          obsMetaData ? obsMetaData.followUpStatusOptions : []
                        }
                        placeholder="Select Follow Up Status"
                        classNamePrefix="select2-selection"
                      />
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleValidator.current.message(
                          "followUpStatus",
                          followUpStatus,
                          "required"
                        )}
                      </div>
                    </Col>
                  </Row>
                  <>
                    <Col md="12" lg="12" sm="12" className="quote-head-content">
                      <p className="quote-head">
                        Future Followup
                        <span className="quote-info">
                          <i
                            style={{ color: "grey" }}
                            id="quoteInfo1"
                            aria-hidden="true"
                            className="fa fa-info-circle ms-1"
                          ></i>
                          <UncontrolledTooltip
                            placement="right"
                            target="quoteInfo1"
                          >
                            Future Followup
                          </UncontrolledTooltip>
                        </span>
                      </p>
                    </Col>
                    <Row className="d-flex flex-row">
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Follow-Up-Date"}
                          >
                            {"Follow-Up-Date"}{" "}
                            <span className="required">*</span>
                          </Label>
                        </div>
                        <Input
                          type="datetime-local"
                          placeholder="Select Date"
                          name="futureFollowUpDate"
                          value={followUpData.futureFollowUpDate}
                          onChange={(e) => handleFollowUpChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Follow-Up-Mode"}{" "}
                            <span className="required">*</span>
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="futureFollowUpMode"
                          value={futureFollowUpMode}
                          onChange={(e) => setFutureFollowUpMode(e)}
                          options={
                            obsMetaData ? obsMetaData.followUpModeOptions : []
                          }
                          placeholder="Select Follow Up Mode"
                          classNamePrefix="select2-selection"
                        />
                        <div style={{ textTransform: "capitalize" }}>
                          {simpleValidator.current.message(
                            "futureFollowUpMode",
                            futureFollowUpMode,
                            "required"
                          )}
                        </div>
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Follow-Up-Strategy"}{" "}
                            <span className="required">*</span>
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="followUpStrategy"
                          value={followUpStrategy}
                          onChange={(e) => setFollowUpStrategy(e)}
                          options={
                            obsMetaData
                              ? obsMetaData.followUpStrategyOptions
                              : []
                          }
                          placeholder="Select Follow Up Strategy"
                          classNamePrefix="select2-selection"
                        />
                        <div style={{ textTransform: "capitalize" }}>
                          {simpleValidator.current.message(
                            "followUpStrategy",
                            followUpStrategy,
                            "required"
                          )}
                        </div>
                      </Col>
                    </Row>
                  </>
                </>
              ) : (
                ""
              )}
              {mode.value === "rejected" ? (
                <>
                  <Row className="quote-head-content">
                    <Col md="6" lg="6" sm="12">
                      <div className="d-flex">
                        <p className="quote-head">
                          Current Followup
                          <span className="quote-info">
                            <i
                              style={{ color: "grey" }}
                              id="quoteInfo1"
                              aria-hidden="true"
                              className="fa fa-info-circle ms-1"
                            ></i>
                            <UncontrolledTooltip
                              placement="right"
                              target="quoteInfo1"
                            >
                              Current Followup
                            </UncontrolledTooltip>
                          </span>
                        </p>
                        <div style={{ width: "150px" }}>
                          <Select
                            type="text"
                            name="mode"
                            value={mode}
                            onChange={(e) => setMode(e)}
                            options={[
                              { label: "Followup", value: "followup" },
                              {
                                label: "Lead Converted",
                                value: "leadConverted",
                              },
                              { label: "Rejected", value: "rejected" },
                            ]}
                            placeholder="Select Follow Up Mode"
                            classNamePrefix="select2-selection"
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row className="d-flex flex-row">
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className="form-label"
                          htmlFor={"Follow-Up-Date"}
                        >
                          {"Follow-Up-Date"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="followUpDate"
                        value={currentDate}
                        onChange={(e) => handleFollowUpChange(e)}
                        disabled
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"Time"}>
                          {"Time"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Input
                        type="text"
                        placeholder="Select Date"
                        name="time"
                        value={currentTime}
                        onChange={(e) => handleFollowUpChange(e)}
                        disabled
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Follow-Up-Mode"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Select
                        type="text"
                        name="rejectedFollowupMode"
                        value={rejectedFollowupMode}
                        onChange={(e) => setRejectedFollowupMode(e)}
                        options={
                          obsMetaData ? obsMetaData.followUpModeOptions : []
                        }
                        placeholder="Select Follow Up Mode"
                        classNamePrefix="select2-selection"
                      />
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleRejectValidator.current.message(
                          "rejectedFollowupMode",
                          rejectedFollowupMode,
                          "required"
                        )}
                        {isEmpty(rejectedFollowupMode) ? (
                          <span className="required">
                            The Followup Mode Field is required
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className={"form-label"}>
                        {"Reject Reason"}
                        <span className="required mx-1">*</span>
                      </Label>
                      <Select
                        type="text"
                        name="rejectReason"
                        value={rejectReason}
                        onChange={(e) => setRejectReason(e)}
                        options={
                          obsMetaData ? obsMetaData.rejectReasonOptions : []
                        }
                        placeholder="Select Reject Reason"
                        classNamePrefix="select2-selection"
                      />
                        <div style={{ textTransform: "capitalize" }}>
                        {simpleRejectValidator.current.message(
                          "Reject Reason",
                          rejectReason,
                          "required"
                        )}
                         {isEmpty(rejectReason) ? (
                          <span className="required">
                            The Reject Reason Field is required
                          </span>
                        ) : (
                          ""
                        )}</div>
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Red Flag"}
                          <span className="required mx-1">*</span>
                        </Label>
                      </div>

                      <div className="d-flex flex-row">
                        {flagOptions.map((item, index) => {
                          return (
                            <>
                              <div className="form-check form-check-inline">
                                <Input
                                  type="radio"
                                  key={item.id}
                                  name="flagOption"
                                  value={flagOption.option}
                                  checked={flagOption.checked === index}
                                  onChange={(e) => handleFlagChange(e, index)}
                                />

                                <Label>{item.label}</Label>
                              </div>
                            </>
                          )
                        })}
                      </div>
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleRejectValidator.current.message(
                          "flagOption",
                          flagOption.option,
                          "required"
                        )}
                        {isEmpty(flagOption.option) ? (
                          <span className="required">
                            The Red Flag Field is required
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Reach Status"}
                          <span className="required">*</span>
                        </Label>
                      </div>

                      <div className="d-flex flex-row">
                        {checkOptions.map((item, index) => {
                          return (
                            <>
                              <div className="form-check form-check-inline">
                                <Input
                                  type="radio"
                                  key={item.id}
                                  name="Reach Status"
                                  value={checkOption.option}
                                  checked={checkOption.checked === index}
                                  onChange={(e) => handleCheckChange(e, index)}
                                />

                                <Label>{item.label}</Label>
                              </div>
                            </>
                          )
                        })}
                      </div>
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleRejectValidator.current.message(
                          "Reach Status",
                          checkOption.option,
                          "required"
                        )}
                        {isEmpty(checkOption.option) ? (
                          <span className="required">
                            The Reach Status Field is required
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Row className="d-flex flex-row mt-3">
                    <Col md="6" lg="6" sm="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"Time"}>
                          {"Follow-Up-Remarks"} {""}{" "}
                          <span className="required">*</span>
                          <span className="text-decoration-underline text-info">
                            History
                          </span>
                        </Label>
                      </div>
                      <Input
                        type="textarea"
                        placeholder="Enter Follow Up Remarks"
                        name="rejectfollowUpRemarks"
                        value={followUpData.rejectfollowUpRemarks}
                        onChange={(e) => handleFollowUpChange(e)}
                      />
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleRejectValidator.current.message(
                          "rejectfollowUpRemarks",
                          followUpData.rejectfollowUpRemarks,
                          "required"
                        )}
                        {isEmpty(followUpData.rejectfollowUpRemarks) ? (
                          <span className="required">
                            The Followup Remarks Field is required
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Attachment"} <span className="required">*</span>
                        </Label>
                      </div>
                      <Button className=" btn btn-warning  position-relative fs-5">
                        <i className="fas fa-laptop"></i>

                        <Input
                          type="file"
                          name="attachmentFile"
                          accept="application/pdf, audio/mp3 , image/jpeg"
                          // id="upload-btn"
                          multiple
                          onChange={(e) => attachmentChange(e)}
                          style={{
                            position: "absolute",
                            fontSize: "50px",
                            opacity: 0,
                            right: 0,
                            top: 0,
                          }}
                        />
                        <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                          {attachFileLength ? attachFileLength : 0}
                        </span>
                      </Button>
                      <div className="text-decoration-underline text-danger">
                        {attachFileName ? attachFileName : ""}
                      </div>
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleRejectValidator.current.message(
                          "Attachment",
                          attachmentFile,
                          "required"
                        )}
                        {isEmpty(attachmentFile) ? (
                          <span className="required">
                            The Attachment Field is required
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>
                  </Row>
                </>
              ) : (
                ""
              )}
              {mode.value === "leadConverted" ? (
                <>
                  <Row className="quote-head-content">
                    <Col md="6" lg="6" sm="12">
                      <div className="d-flex">
                        <p className="quote-head">
                          Current Followup
                          <span className="quote-info">
                            <i
                              style={{ color: "grey" }}
                              id="quoteInfo1"
                              aria-hidden="true"
                              className="fa fa-info-circle ms-1"
                            ></i>
                            <UncontrolledTooltip
                              placement="right"
                              target="quoteInfo1"
                            >
                              Current Followup
                            </UncontrolledTooltip>
                          </span>
                        </p>
                        <div style={{ width: "150px" }}>
                          <Select
                            type="text"
                            name="mode"
                            value={mode}
                            onChange={(e) => setMode(e)}
                            options={[
                              { label: "Followup", value: "followup" },
                              {
                                label: "Lead Converted",
                                value: "leadConverted",
                              },
                              { label: "Rejected", value: "rejected" },
                            ]}
                            placeholder="Select Follow Up Mode"
                            classNamePrefix="select2-selection"
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row className="d-flex flex-row">
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className="form-label"
                          htmlFor={"Follow-Up-Date"}
                        >
                          {"Follow-Up-Date"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="followUpDate"
                        value={currentDate}
                        onChange={(e) => handleFollowUpChange(e)}
                        disabled
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"Time"}>
                          {"Time"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Input
                        type="text"
                        placeholder="Select Date"
                        name="time"
                        value={currentTime}
                        onChange={(e) => handleFollowUpChange(e)}
                        disabled
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Follow-Up-Mode"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Select
                        type="text"
                        name="leadFollowupMode"
                        value={leadFollowupMode}
                        onChange={(e) => setLeadFollowupMode(e)}
                        options={
                          obsMetaData ? obsMetaData.followUpModeOptions : []
                        }
                        placeholder="Select Follow Up Mode"
                        classNamePrefix="select2-selection"
                      />
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleLeadValidator.current.message(
                          "leadFollowupMode",
                          leadFollowupMode,
                          "required"
                        )}
                        {isEmpty(leadFollowupMode) ? (
                          <span className="required">
                            The Lead FollowupMode Field is required
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Reach Status"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <div className="d-flex flex-row">
                        {reachStatusOptions.map((item, index) => {
                          return (
                            <>
                              <div className="form-check form-check-inline">
                                <Input
                                  type="radio"
                                  key={item.id}
                                  name="Reach Status"
                                  value={reachOption.option}
                                  checked={reachOption.checked === index}
                                  onChange={(e) =>
                                    handleReachStatusChange(e, index)
                                  }
                                />

                                <Label>{item.label}</Label>
                              </div>
                            </>
                          )
                        })}
                      </div>
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleLeadValidator.current.message(
                          "Reach Status",
                          reachOption.option,
                          "required"
                        )}
                        {isEmpty(reachOption.option) ? (
                          <span className="required">
                            The Reach Status Field is required
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Row className="d-flex flex-row mt-3">
                    <Col md="6" lg="6" sm="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"Time"}>
                          {"Follow-Up-Remarks"} {""}{" "}
                          <span className="required">*</span>
                          <span className="text-decoration-underline text-info">
                            History
                          </span>
                        </Label>
                      </div>
                      <Input
                        type="textarea"
                        placeholder="Enter Follow Up Remarks"
                        name="leadfollowUpRemarks"
                        value={followUpData.leadfollowUpRemarks}
                        onChange={(e) => handleFollowUpChange(e)}
                      />
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleLeadValidator.current.message(
                          "leadfollowUpRemarks",
                          followUpData.leadfollowUpRemarks,
                          "required"
                        )}
                        {isEmpty(followUpData.leadfollowUpRemarks) ? (
                          <span className="required">
                            The Lead FollowUpRemarks Field is required
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Attachment"} <span className="required">*</span>
                        </Label>
                      </div>
                      <Button className=" btn btn-warning  position-relative fs-5">
                        <i className="fas fa-laptop"></i>

                        <Input
                          type="file"
                          name="uploadAttachment"
                          accept="application/pdf, audio/mp3 , image/png,image/jpeg"
                          // id="upload-btn"
                          multiple
                          onChange={(e) => fileChange(e)}
                          style={{
                            position: "absolute",
                            fontSize: "50px",
                            opacity: 0,
                            right: 0,
                            top: 0,
                          }}
                        />
                        <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                          {uploadFileLength ? uploadFileLength : 0}
                        </span>
                      </Button>
                      <div className="text-decoration-underline text-danger">
                        {uploadFileName ? uploadFileName : ""}
                      </div>
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleLeadValidator.current.message(
                          "Attachment",
                          uploadAttachment,
                          "required"
                        )}
                        {isEmpty(uploadAttachment) ? (
                          <span className="required">
                            The Attachment Field is required
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Row className="d-flex flex-row">
                    <Col md="9" lg="9" sm="12" className="quote-head-content">
                      <p className="quote-head">
                        Cross Promotion
                        <span className="quote-info">
                          <i
                            style={{ color: "grey" }}
                            id="quoteInfo1"
                            aria-hidden="true"
                            className="fa fa-info-circle ms-1"
                          ></i>
                          <UncontrolledTooltip
                            placement="right"
                            target="quoteInfo1"
                          >
                            Cross Promotion
                          </UncontrolledTooltip>
                        </span>
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12">
                      <Button
                        className="btn btn-info"
                        style={{ float: "right" }}
                        onClick={() => addCrossPromotion()}
                      >
                        Add <i className="fa solid fa-plus"></i>
                      </Button>
                    </Col>
                  </Row>
                  {crossPromotionData &&
                    crossPromotionData.length > 0 &&
                    crossPromotionData.map((item, index) => {
                      const companyArray = crossPromotionData.map(
                        (m) => m.companyId
                      )
                      const companyValue = companyArray.toString()
                      console.log(companyValue, "companyvalue")

                      const companyIds = companyValue.split(",")
                      console.log(companyIds, "companyIds")

                      const branchOptions =
                        !isEmpty(obsMetaData) &&
                        obsMetaData.branchOptions.filter(
                          (branch) =>
                            companyIds.includes(branch.companyId) &&
                            (!item.companyId ||
                              item.companyId === branch.companyId)
                        )
                      //const serviceCompanyIds = [...companyIds]
                      const serviceOptions =
                        !isEmpty(obsMetaData) &&
                        obsMetaData.serviceOptions.filter(
                          (service) =>
                            companyIds.includes(service.companyId.toString()) &&
                            (!item.companyId ||
                              item.companyId === service.companyId.toString())
                        )
                      return (
                        <Row key={index}>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Company"} <span className="required">*</span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="companyId"
                              value={
                                item.companyId
                                  ? {
                                    value: item.companyId,
                                    label: item.company,
                                  }
                                  : ""
                              }
                              onChange={(e) =>
                                modalChange(e, index, "companyId")
                              }
                              options={
                                obsMetaData ? obsMetaData.companyOptions : []
                              }
                              placeholder="Select Company"
                              classNamePrefix="select2-selection"
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleLeadValidator.current.message(
                                "company",
                                item.companyId,
                                "required"
                              )}
                              {isEmpty(item.companyId) ? (
                                <span className="required">
                                  The Company Field is required
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Branch"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="branchId"
                              value={
                                item.branchId
                                  ? {
                                    value: item.branchId,
                                    label: item.branch,
                                  }
                                  : ""
                              }
                              onChange={(e) =>
                                modalChange(e, index, "branchId")
                              }
                              options={branchOptions}
                              placeholder="Select Branch"
                              classNamePrefix="select2-selection"
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleLeadValidator.current.message(
                                "branch",
                                item.branchId,
                                "required"
                              )}
                              {isEmpty(item.branchId) ? (
                                <span className="required">
                                  The Branch Field is required
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="13" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Service"} <span className="required">*</span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="serviceId"
                              value={
                                item.serviceId
                                  ? {
                                    value: item.serviceId,
                                    label: item.service,
                                  }
                                  : ""
                              }
                              onChange={(e) =>
                                modalChange(e, index, "serviceId")
                              }
                              options={serviceOptions}
                              placeholder="Select Service"
                              classNamePrefix="select2-selection"
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleLeadValidator.current.message(
                                "service",
                                item.serviceId,
                                "required"
                              )}
                              {isEmpty(item.serviceId) ? (
                                <span className="required">
                                  The Service is required
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Sales Urge"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Select
                        type="text"
                        name="convertSalesUrgeId"
                        value={
                          item.convertSalesUrgeId
                            ? {
                              value: item.convertSalesUrgeId,
                              label: item.convertSalesUrge,
                            }
                            : ""
                        }
                        onChange={(e) =>
                          modalChange(e, index, "convertSalesUrgeId")
                        }
                        options={
                         [{label:"Hot",value:"hot"},{label:"Warm",value:"warm"},{label:"Cold",value:"cold"}]
                        }
                        placeholder="Select Follow Up Mode"
                        classNamePrefix="select2-selection"
                      />
                      <div style={{ textTransform: "capitalize" }}>
                              {simpleLeadValidator.current.message(
                                "SalesUrge",
                                item.convertSalesUrgeId,
                                "required"
                              )}
                              {isEmpty(item.convertSalesUrgeId) ? (
                                <span className="required">
                                  The Sales Urge is required
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                    </Col>
                          <Col lg="2" md="2" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Remarks"} <span className="required">*</span>
                              </Label>
                            </div>

                            <Input
                              type="text"
                              name="followUpRemarks"
                              value={item.followUpRemarks}
                              placeholder="Enter Remarks"
                              onChange={(e) =>
                                modalChange(e, index, "followUpRemarks")
                              }
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleLeadValidator.current.message(
                                "Remarks",
                                item.followUpRemarks,
                                "required"
                              )}
                              {isEmpty(item.followUpRemarks) ? (
                                <span className="required">
                                  The Remarks is required
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </Col>

                          <Col
                            lg="1"
                            md="1"
                            sm="12"
                            xs="12"
                            className="float-right"
                          >
                            <i
                              className="fa fa-times mt-5 font-size-20"
                              style={{ color: "#db4343", cursor: "pointer" }}
                              onClick={() => removeCrossPromotion(index)}
                            ></i>
                          </Col>
                        </Row>
                      )
                    })}
                </>
              ) : (
                ""
              )}
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => {
                  setFollowUpModal(false)
                  setCheckOption({ option: "", checked: "" })
                  setRadioOption({ option: "", checked: "" })
                  setReachOption({ option: "", checked: "" })
                  setFileName("")
                  setFileLength("")
                  setAttachFileName("")
                  setAttachFileLength("")
                  setUploadFileName("")
                  setUploadFileLength("")
                }}
              >
                Cancel
              </Button>
              {mode.value === "followup" ? (
                <>
                  <Button
                    type="button"
                    variant="primary"
                    className="btn btn-success"
                    onClick={() => {
                      submitCrossPromotion()
                    }}
                  >
                    Submit
                  </Button>
                </>
              ) : mode.value === "rejected" ? (
                <>
                  <Button
                    type="button"
                    variant="primary"
                    className="btn btn-success"
                    onClick={() => {
                      rejectedSubmit()
                    }}
                  >
                    Submit
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    type="button"
                    variant="primary"
                    className="btn btn-success"
                    onClick={() => {
                      leadConveretedSubmit()
                    }}
                  >
                    Submit
                  </Button>
                </>
              )}
            </Modal.Footer>
          </Modal>
        )}
        {followUpHistoryModal && (
          <Modal size="xl" scrollable={true} show={followUpHistoryModal}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Followup History
            </Modal.Header>
            <Modal.Body>
              <Col md="12" lg="12" xl="12" className="mt-5">
                <Table striped bordered responsive>
                  <thead>
                    <tr>
                      <th>S.No</th>

                      <th>Followup Date And Time</th>
                      <th>Followup Mode</th>

                      <th>Reach Status</th>
                      <th>Followup Remarks</th>
                      <th>Followup Status</th>

                      <th>Attachment</th>
                      <th>Future Followup Date And Time</th>
                      <th>Future Followup</th>

                      <th>Followup Strategy</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(followup_list) && followup_list.length > 0 ? (
                      followup_list.map((item, index) => {
                        var attachments = !isEmpty(item.recordAttachment)
                          ? item.recordAttachment.map((f) => f)
                          : []

                        // console.log(str, "string attachments")
                        const fileUrl = isEmpty(item.recordAttachment)
                          ? ""
                          : item.recordAttachment.map((data) =>
                            data.split(".").pop()
                          )
                        // console.log(fileUrl, "string attachments")
                        // console.log(attachments, "attachment with alpha url")
                        const colorCode =
                          !isEmpty(obsMetaData) &&
                          obsMetaData.processStatusOptions &&
                          obsMetaData.processStatusOptions.length > 0 &&
                          obsMetaData.processStatusOptions.find(
                            (_) => _.processStatusId === item.processStatus
                          ) &&
                          obsMetaData.processStatusOptions.find(
                            (_) => _.processStatusId === item.processStatus
                          ).colorCode

                        const followpDate = !isEmpty(item.followUpDate)
                          ? moment(item.followUpDate)
                            .subtract(5, "hours")
                            .subtract(30, "minutes")
                            .format(dateFormate)
                          : "--"
                        const futureFollowUpDateTime = !isEmpty(
                          item.futureFollowUpDateTime
                        )
                          ? moment(item.futureFollowUpDateTime)
                            .subtract(5, "hours")
                            .subtract(30, "minutes")
                            .format(`${dateFormate} hh:mm A`)
                          : "--"

                        return (
                          <>
                            <tr key={item._id}>
                              <td>{index + 1}</td>

                              <td>{followpDate + " " + item.followUpTime}</td>
                              <td>{item.followupModeId}</td>
                              <td>{item.clientReachStatus}</td>
                              <td>{item.followUpRemarks}</td>
                              <td>
                                {!isEmpty(item.followUpStatus)
                                  ? item.followUpStatus
                                  : "--"}
                              </td>
                              <td>
                                {fileUrl[0] === "jpeg" ||
                                  fileUrl[0] === "jpg" ||
                                  fileUrl[0] === "png" ? (
                                  <a
                                    onClick={() =>
                                      window.open(attachments, "_blank")
                                    }
                                  >
                                    <span
                                      style={{
                                        textDecoration: "underline",
                                        color: "#E40D8C",
                                      }}
                                    >
                                      View
                                    </span>
                                  </a>
                                ) : fileUrl[0] === "mp3" ||
                                  fileUrl[0] === "m4a" ||
                                  fileUrl[0] === "mp4" ? (
                                  <a href={attachments}>
                                    <audio controls>
                                      <source
                                        src={attachments}
                                        type="audio/mpeg"
                                      />
                                      Your browser does not support the audio
                                      element.
                                    </audio>
                                  </a>
                                ) : isEmpty(attachments) ? (
                                  "--"
                                ) : (
                                  "--"
                                )}
                              </td>
                              <td>{futureFollowUpDateTime}</td>
                              <td>
                                {!isEmpty(item.futureFollowupModeId)
                                  ? item.futureFollowupModeId
                                  : "--"}
                              </td>
                              <td>{item.futureFollowUpStrategy}</td>
                              <td>
                                <button
                                  style={{
                                    background: colorCode,
                                    border: "none",
                                    cursor: "pointer",
                                    color: "white",
                                    padding: "2px",
                                    borderRadius: "4px",
                                  }}
                                >
                                  {item.processStatusName}
                                </button>
                              </td>
                            </tr>
                          </>
                        )
                      })
                    ) : (
                      <>
                        <tr key={0}>
                          <td colSpan={13} className="text-align-center">
                            No record found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </Table>
              </Col>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => setFollowUpHistoryModal(false)}
              >
                Close
              </Button>
              {/* <Button
                variant="primary"
                className="btn btn-success"
                onClick={() => setFollowUpHistoryModal(false)}
              >
                Submit
              </Button> */}
            </Modal.Footer>
          </Modal>
        )}
        {importLoading ? (
          <Modal
            show={importLoading}
            style={{ width: "7%", margin: "18% 50%" }}
          >
            <Modal.Body>
              <Spinner
                as="span"
                animation="grow"
                size="lg"
                role="status"
                aria-hidden="true"
                variant="success"
                className="mx-2"
                color="success"
              />
              {/* <span>Loading...</span> */}
            </Modal.Body>
          </Modal>
        ) : (
          ""
        )}
          {agentAssignModal && (
          <Modal size="md" show={agentAssignModal}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Update Obs Agent
            </Modal.Header>
            <Modal.Body>
              <Col lg="7" md="7" sm="7" xs="7">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"}>{"Sales Agent"}</Label>
                </div>
                <ReactSearchAutocomplete
                  name="agent"
                  key = {agentKey}
                  items={obsMetaData.employeeOptions}
                  value={agent}
                  type="autoComplete"
                  resultStringKeyName="label"
                  showIcon={false}
                  onSelect={(e) => setAgent(e)}
                  onChange={(e) => setAgent(e.target.value)}
                  placeholder="Enter Sales Agent"
                  fuseOptions={fuseAgentOptions} // Search on both fields
                  styling={{
                    height: "34px",
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    backgroundColor: "white",
                    boxShadow: "none",
                    hoverBackgroundColor: "#E40D8C",
                    color: "black",
                    fontSize: "12px",
                    fontFamily: "Courier",
                    iconColor: "green",
                    clearIconMargin: "3px 8px 0 0",
                    zIndex: 10,
                  }}
                />
              </Col>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => {
                  setAgentAssignModal(false)
                  setRowSelected(false)
                  setSelectedRows([])
                }}
              >
                Close
              </Button>
              <Button
                variant="primary"
                className="btn btn-success"
                onClick={() => updateAgent()}
              >
                Update
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </React.Fragment>
  )
}
ManageObsDetails.propTypes = {
  dispatch: PropTypes.func,
  //recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  name: PropTypes.any,
  searchBarStyle: PropTypes.any,
  csvProps: PropTypes.any,
  FlagExportExcel: PropTypes.any,
  FlagImportInward: PropTypes.any,
  FlagTableSearch: PropTypes.any,
  columns: PropTypes.any,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManageObsDetails)
)
